<template>
  <div>
    <div class="nav-box">
      <Nav @hanldRoute="hanldRoute"></Nav>
    </div>
    <div class="
        head">
      <img
        src="@/assets/精致眼眉/banner.jpg"
        alt=""
      >
    </div>
    <div class="bigbox">
      <div
        class="product"
        v-for="(item,index) in productArr"
      >
        <div class="product-box">
          <div class="default">
            <img :src="item.default">
            <div class="describe">
              <div class="describe1">{{item.describe1}}</div>
              <div class="describe2">{{item.describe2}}</div>
            </div>
            <!-- <img :src="item.describe"> -->
          </div>
          <div class="active">
            <img :src="item.active">
          </div>
        </div>
      </div>
    </div>
    <div>
      <Bot></Bot>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import Bot from '@/components/Bot.vue';
import { categoryDetails } from './detail';

export default {
  data() {
    return {
      productArr: []
    }
  },
  components: {
    Nav, Bot
  },
  created() {
    this.productArr = categoryDetails
  }
}
</script>

<style lang="scss" scoped>
.head {
  img {
    width: 100%;
  }
}
.bigbox {
  display: flex;
  flex-wrap: wrap;
}
.product {
  width: 33.333%;
  .product-box {
    width: 100%;
    position: relative;
    overflow: hidden;
    .default {
      cursor: pointer;
      width: 100%;
      img {
        width: 100%;
      }
      .describe {
        width: 100%;
        height: 4.875rem;
        // background: chartreuse;
        padding: 1.875rem 2.5rem;
        .describe1 {
          font-weight: 700;
          font-size: 1.625rem;
          padding-bottom: 0.9375rem;
          letter-spacing: 1px;
          color: #5e5e5e;
        }
        .describe2 {
          letter-spacing: 1.5px;
          font-weight: normal;
          color: #656565;
          font-size: 1.25rem;
        }
      }
    }
    .active {
      cursor: pointer;
      width: 100%;
      position: absolute;
      top: 0;
      right: -100%;
      transition: 1s;
      img {
        width: 100%;
      }
    }
  }
  // .product-box:hover .active {
  //   transition: 0.7s;
  //   right: 0px;
  // }
}
.product:nth-of-type(11),
.product:nth-of-type(9) {
  .describe1 {
    text-indent: -1rem;
  }
}
</style>